/* ============================================================
   ODORARE PARFUMERIE — QUICK VIEW PANEL LATÉRAL v5
   Nécessite : templates/product.quickview.liquid
   ============================================================ */

(function () {
  'use strict';

  /* ── CSS ─────────────────────────────────────────────────── */
  const CSS = `
    .oqv-overlay {
      position: fixed; inset: 0;
      background: rgba(10,8,6,0.55);
      backdrop-filter: blur(3px);
      -webkit-backdrop-filter: blur(3px);
      z-index: 9998; opacity: 0; pointer-events: none;
      transition: opacity 0.4s ease;
    }
    .oqv-overlay.is-open { opacity: 1; pointer-events: all; }

    .oqv-panel {
      position: fixed; top: 0; right: 0; bottom: 0;
      width: min(520px, 100vw);
      background: #faf9f7;
      z-index: 9999;
      display: flex; flex-direction: column;
      transform: translateX(100%);
      transition: transform 0.45s cubic-bezier(0.16,1,0.3,1);
      box-shadow: -8px 0 48px rgba(0,0,0,0.18);
    }
    .oqv-panel.is-open { transform: translateX(0); }

    .oqv-header {
      display: flex; align-items: center; justify-content: space-between;
      padding: 18px 32px; border-bottom: 1px solid #e8e4de;
      background: #faf9f7; flex-shrink: 0;
    }
    .oqv-header-label {
      font-family: 'Instrument Sans', sans-serif;
      font-size: 10px; letter-spacing: 0.22em;
      text-transform: uppercase; color: #8a7f74;
    }
    .oqv-close {
      width: 36px; height: 36px;
      display: flex; align-items: center; justify-content: center;
      background: none; border: none; cursor: pointer;
      color: #1c1c1c; transition: opacity 0.2s;
    }
    .oqv-close:hover { opacity: 0.5; }
    .oqv-close svg { width: 16px; height: 16px; }

    .oqv-body {
      flex: 1; overflow-y: auto;
      overscroll-behavior: contain; scroll-behavior: smooth;
    }
    .oqv-body::-webkit-scrollbar { width: 4px; }
    .oqv-body::-webkit-scrollbar-thumb { background: #d4cec6; border-radius: 2px; }

    /* LOADER */
    .oqv-loader {
      display: flex; align-items: center; justify-content: center;
      height: 300px; gap: 8px;
    }
    .oqv-loader span {
      width: 6px; height: 6px; background: #1c1c1c;
      border-radius: 50%;
      animation: oqv-pulse 1.2s ease-in-out infinite;
    }
    .oqv-loader span:nth-child(2) { animation-delay: 0.2s; }
    .oqv-loader span:nth-child(3) { animation-delay: 0.4s; }
    @keyframes oqv-pulse {
      0%,80%,100% { transform: scale(0.6); opacity: 0.3; }
      40% { transform: scale(1); opacity: 1; }
    }

    /* GALERIE */
    .oqv-gallery {
      position: relative; background: #f2efe9;
      height: 300px; overflow: hidden; flex-shrink: 0;
    }
    .oqv-gallery-main {
      width: 100%; height: 100%;
      object-fit: contain;
      display: block;
      padding: 20px; box-sizing: border-box;
      transition: opacity 0.25s ease;
    }
    .oqv-gallery-thumbs {
      position: absolute; bottom: 10px; left: 0; right: 0;
      display: flex; justify-content: center; gap: 6px; padding: 0 12px;
    }
    .oqv-thumb {
      width: 44px; height: 44px; object-fit: cover;
      cursor: pointer; border: 2px solid transparent;
      opacity: 0.55; transition: all 0.2s; background: #fff;
    }
    .oqv-thumb:hover, .oqv-thumb.active { border-color: #1c1c1c; opacity: 1; }

    .oqv-badge {
      position: absolute; top: 14px; left: 14px;
      font-family: 'Instrument Sans', sans-serif;
      font-size: 9px; letter-spacing: 0.18em;
      text-transform: uppercase; padding: 4px 10px;
      background: #1c1c1c; color: #fff; z-index: 2;
    }

    /* INFOS */
    .oqv-info { padding: 24px 32px 16px; }

    .oqv-vendor {
      font-family: 'Instrument Sans', sans-serif;
      font-size: 10px; letter-spacing: 0.2em;
      text-transform: uppercase; color: #8a7f74; margin: 0 0 6px;
    }
    .oqv-title {
      font-family: 'Instrument Sans', sans-serif;
      font-size: 20px; letter-spacing: 0.08em;
      text-transform: uppercase; font-weight: 400;
      color: #1c1c1c; margin: 0 0 10px; line-height: 1.25;
    }
    .oqv-price-row {
      display: flex; align-items: baseline; gap: 10px; margin-bottom: 18px;
    }
    .oqv-price { font-family: 'Nunito', sans-serif; font-size: 19px; color: #1c1c1c; }
    .oqv-price-compare {
      font-family: 'Nunito', sans-serif;
      font-size: 14px; color: #b0a99e; text-decoration: line-through;
    }
    .oqv-sep { height: 1px; background: #e8e4de; margin: 0 0 18px; }

    /* DESCRIPTION */
    .oqv-description {
      font-family: 'Nunito', sans-serif;
      font-size: 13px; line-height: 1.75; color: #5a534a; margin-bottom: 18px;
    }

    /* TABLEAU METAFIELDS */
    .oqv-meta-table {
      width: 100%; margin-bottom: 18px; border-collapse: collapse;
    }
    .oqv-meta-table tr { border-bottom: 1px solid #ede9e3; }
    .oqv-meta-table tr:last-child { border-bottom: none; }
    .oqv-meta-table td {
      padding: 9px 0; vertical-align: middle;
      font-family: 'Nunito', sans-serif; font-size: 13px;
    }
    .oqv-meta-table td:first-child {
      font-family: 'Instrument Sans', sans-serif;
      font-size: 11px; letter-spacing: 0.06em;
      font-weight: 600; color: #1c1c1c;
      width: 42%; padding-right: 16px;
    }
    .oqv-meta-table td:last-child { color: #5a534a; padding-right: 32px; }

    /* PYRAMIDE OLFACTIVE */
    .oqv-pyramide {
      margin-bottom: 18px;
    }
    .oqv-pyramide-title {
      font-family: 'Instrument Sans', sans-serif;
      font-size: 10px; letter-spacing: 0.18em;
      text-transform: uppercase; color: #8a7f74;
      margin: 0 0 10px;
    }
    .oqv-pyramide-content {
      font-family: 'Nunito', sans-serif;
      font-size: 13px; line-height: 1.75; color: #5a534a;
    }
    .oqv-pyramide-content p { margin: 0 0 6px; }
    .oqv-pyramide-content strong { color: #1c1c1c; font-weight: 600; }
    .oqv-pyramide-content span { background: none !important; }

    /* VARIANTS */
    .oqv-variants { margin-bottom: 18px; }
    .oqv-variants-header {
      font-family: 'Instrument Sans', sans-serif;
      font-size: 9px; letter-spacing: 0.18em;
      text-transform: uppercase; color: #1c1c1c;
      margin: 0 0 10px;
      display: flex; justify-content: space-between; align-items: center;
    }
    .oqv-variants-header em { font-style: normal; color: #8a7f74; }
    .oqv-variant-buttons { display: flex; flex-wrap: wrap; gap: 7px; }
    .oqv-variant-btn {
      font-family: 'Nunito', sans-serif; font-size: 12px;
      padding: 8px 16px; border: 1px solid #d4cec6;
      background: #fff; color: #1c1c1c;
      cursor: pointer; transition: all 0.2s;
    }
    .oqv-variant-btn:hover { border-color: #1c1c1c; }
    .oqv-variant-btn.active { background: #1c1c1c; border-color: #1c1c1c; color: #fff; }
    .oqv-variant-btn.unavailable { opacity: 0.3; cursor: not-allowed; text-decoration: line-through; }

    /* FOOTER */
    .oqv-footer {
      flex-shrink: 0; padding: 16px 32px 24px;
      border-top: 1px solid #e8e4de; background: #faf9f7;
      display: flex; flex-direction: column; gap: 9px;
    }
    .oqv-stock-msg {
      font-family: 'Nunito', sans-serif; font-size: 11px;
      color: #8a7f74; text-align: center;
    }
    .oqv-stock-msg.low { color: #c0392b; }
    .oqv-atc {
      width: 100%; padding: 15px;
      background: #1c1c1c; color: #fff; border: none;
      font-family: 'Instrument Sans', sans-serif;
      font-size: 10px; letter-spacing: 0.22em; text-transform: uppercase;
      cursor: pointer; transition: background 0.2s, opacity 0.2s;
    }
    .oqv-atc:hover { background: #333; }
    .oqv-atc:disabled { opacity: 0.4; cursor: not-allowed; }
    .oqv-view-full {
      width: 100%; padding: 12px; background: transparent;
      color: #1c1c1c; border: 1px solid #1c1c1c;
      font-family: 'Instrument Sans', sans-serif;
      font-size: 10px; letter-spacing: 0.18em; text-transform: uppercase;
      cursor: pointer; text-decoration: none; text-align: center;
      display: block; transition: all 0.2s; box-sizing: border-box;
    }
    .oqv-view-full:hover { background: #1c1c1c; color: #fff; }

    /* BOUTON APERÇU SUR VIGNETTE */
    .oqv-trigger-btn {
      position: absolute; bottom: 10px; left: 50%;
      transform: translateX(-50%) translateY(6px);
      background: rgba(28,28,28,0.9); color: #fff; border: none;
      font-family: 'Instrument Sans', sans-serif;
      font-size: 9px; letter-spacing: 0.2em; text-transform: uppercase;
      padding: 9px 16px; cursor: pointer; white-space: nowrap;
      opacity: 0; transition: opacity 0.25s ease, transform 0.25s ease;
      z-index: 10; pointer-events: none;
    }
    .product-card:hover .oqv-trigger-btn,
    .product-card__figure:hover .oqv-trigger-btn {
      opacity: 1; transform: translateX(-50%) translateY(0); pointer-events: all;
    }

    /* TOAST */
    .oqv-toast {
      position: fixed; bottom: 24px; left: 50%;
      transform: translateX(-50%) translateY(20px);
      background: #1c1c1c; color: #fff;
      font-family: 'Instrument Sans', sans-serif;
      font-size: 10px; letter-spacing: 0.15em; text-transform: uppercase;
      padding: 13px 26px; z-index: 10000;
      opacity: 0; transition: all 0.35s ease; pointer-events: none;
    }
    .oqv-toast.show { opacity: 1; transform: translateX(-50%) translateY(0); }

    @media (max-width: 600px) {
      .oqv-panel { width: 100vw; }
      .oqv-gallery { height: 240px; }
      .oqv-info { padding: 20px 20px 12px; }
      .oqv-footer { padding: 14px 20px 20px; }
      .oqv-header { padding: 16px 20px; }
    }
  `;

  const styleEl = document.createElement('style');
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  /* ── DOM ─────────────────────────────────────────────────── */
  const overlay = document.createElement('div');
  overlay.className = 'oqv-overlay';

  const panel = document.createElement('div');
  panel.className = 'oqv-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.innerHTML = `
    <div class="oqv-header">
      <span class="oqv-header-label">Aperçu rapide</span>
      <button class="oqv-close" aria-label="Fermer">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M1 1l14 14M1 15L15 1"/>
        </svg>
      </button>
    </div>
    <div class="oqv-body" id="oqv-body-content">
      <div class="oqv-loader"><span></span><span></span><span></span></div>
    </div>
    <div class="oqv-footer" id="oqv-footer" style="display:none">
      <div class="oqv-stock-msg" id="oqv-stock-msg"></div>
      <button class="oqv-atc" id="oqv-atc-btn">Ajouter au panier</button>
      <a class="oqv-view-full" id="oqv-view-full" href="#">Voir la fiche complète</a>
    </div>
  `;

  const toast = document.createElement('div');
  toast.className = 'oqv-toast';

  document.body.appendChild(overlay);
  document.body.appendChild(panel);
  document.body.appendChild(toast);

  /* ── State ───────────────────────────────────────────────── */
  let currentProduct = null;
  let selectedVariantId = null;
  let isOpen = false;

  /* ── Helpers ─────────────────────────────────────────────── */
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function showToast(msg) {
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
  }

  function openPanel() {
    isOpen = true;
    overlay.classList.add('is-open');
    panel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    isOpen = false;
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function buildPriceHTML(price, comparePrice) {
    const p  = parseInt(price, 10) || 0;
    const cp = parseInt(comparePrice, 10) || 0;
    return cp > p
      ? `<span class="oqv-price">${formatMoney(p)}</span>
         <span class="oqv-price-compare">${formatMoney(cp)}</span>`
      : `<span class="oqv-price">${formatMoney(p)}</span>`;
  }

  /* ── Convertit tout type de metafield en string lisible ─────
     Gère : string, number, array, objet {value:...}
  ─────────────────────────────────────────────────────────── */
  function toStr(val) {
    if (val === null || val === undefined) return null;
    if (typeof val === 'object' && !Array.isArray(val)) {
      if (val.value !== undefined) return toStr(val.value);
      return null;
    }
    if (Array.isArray(val)) {
      const items = val.map(toStr).filter(Boolean);
      return items.length ? items.join(', ') : null;
    }
    const s = String(val).trim();
    if (!s || s === 'null' || s === 'undefined' || s === '[]' || s === '{}') return null;
    return s;
  }

  /* ── Nettoie le HTML Prestashop (retire styles inline) ────── */
  function cleanHtml(html) {
    if (!html) return null;
    return html
      .replace(/\s*style="[^"]*"/gi, '')        // retire tous les style="..."
      .replace(/\s*class="[^"]*"/gi, '')         // retire tous les class="..."
      .replace(/<span>/gi, '')                   // retire les spans vides
      .replace(/<\/span>/gi, '')
      .replace(/<p>/gi, '<p style="margin:0 0 5px">')  // reset margin des <p>
      .replace(/•/g, '·')                        // bullets plus propres
      .trim();
  }

  /* ── Fetch produit ───────────────────────────────────────── */
  async function fetchProduct(handle) {
    // 1. Template quickview (métafields complets)
    try {
      const res = await fetch('/products/' + handle + '?view=quickview');
      if (res.ok) {
        const text = await res.text();
        const data = JSON.parse(text.trim());
        if (data && data.id) return { source: 'liquid', data };
      }
    } catch (e) { /* template pas encore créé */ }

    // 2. Fallback API .js
    const res2 = await fetch('/products/' + handle + '.js');
    if (!res2.ok) throw new Error('Produit introuvable');
    const data = await res2.json();
    return { source: 'api', data };
  }

  /* ── Rendu produit ───────────────────────────────────────── */
  function renderProduct(fetched) {
    const product = fetched.data;
    const body    = document.getElementById('oqv-body-content');
    const footer  = document.getElementById('oqv-footer');
    const variant = product.variants[0];
    selectedVariantId = variant.id;
    currentProduct = product;

    /* Images */
    const images = (product.images || []).slice(0, 8);
    const mainSrc = images[0] || '';
    const thumbsHTML = images.length > 1
      ? images.map((img, i) => {
          const src = String(img).replace(/(\.\w+)(\?.*)?$/, '_80x80$1');
          return `<img class="oqv-thumb ${i === 0 ? 'active' : ''}"
                       src="${src}" data-full="${img}" alt="" loading="lazy">`;
        }).join('')
      : '';

    /* Badge promo */
    const badgeHTML = (parseInt(variant.compare_at_price) > parseInt(variant.price))
      ? `<div class="oqv-badge">Promo</div>` : '';

    /* Description courte */
    const tmp = document.createElement('div');
    tmp.innerHTML = product.description || '';
    const fullText = (tmp.textContent || '').trim();
    const words = fullText.split(/\s+/);
    const shortDesc = words.slice(0, 50).join(' ') + (words.length > 50 ? '…' : '');

    /* Tags fallback */
    const tags = Array.isArray(product.tags)
      ? product.tags
      : String(product.tags || '').split(',').map(t => t.trim()).filter(Boolean);

    function getTag(prefix) {
      const t = tags.find(t => t.toLowerCase().startsWith(prefix.toLowerCase() + ':'));
      return t ? t.slice(prefix.length + 1).trim() : null;
    }

    /* ── Métafields ─────────────────────────────────────────
       Priorité : template liquid → tags produit
    ────────────────────────────────────────────────────────── */
    const parfumeur     = toStr(product.parfumeur)        || getTag('parfumeur')    || null;
    const famille       = toStr(product.famille_olfactive) || getTag('famille')     || null;
    const facette       = toStr(product.facette)           || getTag('facette')      || null;
    const concentration = toStr(product.concentration)     || getTag('concentration')|| null;

    /* Pyramide olfactive (champ HTML riche depuis Prestashop) */
    const pyramideRaw = toStr(product.pyramide_olfactive) || null;
    const pyramideHtml = pyramideRaw ? cleanHtml(pyramideRaw) : null;

    /* Tableau infos — seulement les champs renseignés */
    const metaRows = [
      parfumeur     && `<tr><td>Parfumeur</td><td>${parfumeur}</td></tr>`,
      famille       && `<tr><td>Famille olfactive</td><td>${famille}</td></tr>`,
      facette       && `<tr><td>Facette</td><td>${facette}</td></tr>`,
      concentration && `<tr><td>Concentration</td><td>${concentration}</td></tr>`,
    ].filter(Boolean);

    const metaHTML = metaRows.length ? `
      <div class="oqv-sep"></div>
      <table class="oqv-meta-table">${metaRows.join('')}</table>` : '';

    /* Pyramide olfactive */
    const pyramideHTML = pyramideHtml ? `
      <div class="oqv-sep"></div>
      <div class="oqv-pyramide">
        <p class="oqv-pyramide-title">Pyramide olfactive</p>
        <div class="oqv-pyramide-content">${pyramideHtml}</div>
      </div>` : '';

    /* Variants */
    const hasVariants = product.variants.length > 1 ||
      (product.variants.length === 1 && product.variants[0].title !== 'Default Title');

    let optionName = 'Contenance';
    if (product.options && product.options.length > 0) {
      const opt = product.options[0];
      optionName = typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : 'Contenance');
    }

    const firstLabel = variant.option1 && variant.option1 !== 'Default Title'
      ? variant.option1 : (variant.title !== 'Default Title' ? variant.title : '');

    const variantsHTML = hasVariants ? `
      <div class="oqv-sep"></div>
      <div class="oqv-variants">
        <p class="oqv-variants-header">
          ${optionName}
          <em id="oqv-selected-label">${firstLabel}</em>
        </p>
        <div class="oqv-variant-buttons">
          ${product.variants.map(v => {
            const lbl = (v.option1 && v.option1 !== 'Default Title') ? v.option1 : v.title;
            const displayTitle = v.title !== 'Default Title' ? v.title : lbl;
            return `<button
              class="oqv-variant-btn ${v.id === variant.id ? 'active' : ''} ${!v.available ? 'unavailable' : ''}"
              data-id="${v.id}"
              data-price="${v.price}"
              data-compare="${v.compare_at_price || 0}"
              data-label="${displayTitle}"
              data-avail="${v.available ? '1' : '0'}"
              ${!v.available ? 'disabled' : ''}
            >${lbl}</button>`;
          }).join('')}
        </div>
      </div>` : '';

    /* Rendu final */
    body.innerHTML = `
      <div class="oqv-gallery">
        ${badgeHTML}
        <img class="oqv-gallery-main" id="oqv-main-img" src="${mainSrc}" alt="${product.title}">
        ${images.length > 1 ? `<div class="oqv-gallery-thumbs">${thumbsHTML}</div>` : ''}
      </div>
      <div class="oqv-info">
        ${product.vendor ? `<p class="oqv-vendor">${product.vendor}</p>` : ''}
        <h2 class="oqv-title">${product.title}</h2>
        <div class="oqv-price-row" id="oqv-price-row">
          ${buildPriceHTML(variant.price, variant.compare_at_price)}
        </div>
        ${shortDesc ? `<div class="oqv-sep"></div><div class="oqv-description">${shortDesc}</div>` : ''}
        ${metaHTML}
        ${pyramideHTML}
        ${variantsHTML}
      </div>
    `;

    footer.style.display = 'flex';
    updateStockMessage(variant);
    document.getElementById('oqv-view-full').href = '/products/' + product.handle;

    /* Events thumbnails */
    body.querySelectorAll('.oqv-thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        body.querySelectorAll('.oqv-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const main = document.getElementById('oqv-main-img');
        main.style.opacity = '0';
        setTimeout(() => { main.src = thumb.dataset.full; main.style.opacity = '1'; }, 180);
      });
    });

    /* Events variants */
    body.querySelectorAll('.oqv-variant-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.dataset.avail === '0') return;
        body.querySelectorAll('.oqv-variant-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        selectedVariantId = parseInt(btn.dataset.id, 10);

        document.getElementById('oqv-price-row').innerHTML =
          buildPriceHTML(btn.dataset.price, btn.dataset.compare);

        const lbl = document.getElementById('oqv-selected-label');
        if (lbl) lbl.textContent = btn.dataset.label;

        const v = currentProduct.variants.find(x => x.id === selectedVariantId);
        if (v) updateStockMessage(v);
      });
    });
  }

  /* ── Stock ───────────────────────────────────────────────── */
  function updateStockMessage(variant) {
    const msg = document.getElementById('oqv-stock-msg');
    const atc = document.getElementById('oqv-atc-btn');
    if (!variant.available) {
      msg.textContent = 'Rupture de stock';
      msg.className = 'oqv-stock-msg low';
      atc.disabled = true; atc.textContent = 'Indisponible';
    } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
      msg.textContent = 'Plus que ' + variant.inventory_quantity + ' en stock';
      msg.className = 'oqv-stock-msg low';
      atc.disabled = false; atc.textContent = 'Ajouter au panier';
    } else {
      msg.textContent = '';
      msg.className = 'oqv-stock-msg';
      atc.disabled = false; atc.textContent = 'Ajouter au panier';
    }
  }

  /* ── Add to cart ─────────────────────────────────────────── */
  async function addToCart(variantId) {
    const atc = document.getElementById('oqv-atc-btn');
    atc.disabled = true; atc.textContent = 'Ajout en cours…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error();
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('.header__cart-dot, cart-dot').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.add('is-visible');
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      closePanel();
      showToast('Produit ajouté au panier ✓');
    } catch {
      atc.textContent = 'Erreur — réessayer';
      atc.disabled = false;
      setTimeout(() => { atc.textContent = 'Ajouter au panier'; }, 2500);
    }
  }

  /* ── Open quick view ─────────────────────────────────────── */
  async function openQuickView(handle) {
    const body   = document.getElementById('oqv-body-content');
    const footer = document.getElementById('oqv-footer');
    body.innerHTML = '<div class="oqv-loader"><span></span><span></span><span></span></div>';
    footer.style.display = 'none';
    openPanel();

    try {
      const fetched = await fetchProduct(handle);
      renderProduct(fetched);
    } catch {
      body.innerHTML = `
        <div style="padding:48px 32px;text-align:center;color:#8a7f74;
          font-size:13px;font-family:'Nunito',sans-serif;">
          Impossible de charger ce produit.<br>
          <a href="/products/${handle}"
             style="color:#1c1c1c;margin-top:14px;display:inline-block;
             font-family:'Instrument Sans',sans-serif;font-size:10px;
             letter-spacing:0.15em;text-transform:uppercase;
             border-bottom:1px solid #1c1c1c;padding-bottom:2px;">
            Voir la fiche complète
          </a>
        </div>`;
    }
  }

  /* ── Injection boutons vignettes ─────────────────────────── */
  function injectTriggerButtons() {
    document.querySelectorAll('product-card, .product-card').forEach(card => {
      if (card.querySelector('.oqv-trigger-btn')) return;
      const handle = card.getAttribute('handle') ||
        card.querySelector('a[href*="/products/"]')
          ?.getAttribute('href')?.match(/\/products\/([^?#/]+)/)?.[1];
      if (!handle) return;
      const figure = card.querySelector('.product-card__figure') || card;
      figure.style.position = 'relative';
      const btn = document.createElement('button');
      btn.className = 'oqv-trigger-btn';
      btn.textContent = 'Aperçu rapide';
      btn.dataset.handle = handle;
      figure.appendChild(btn);
    });
  }

  /* ── Events ──────────────────────────────────────────────── */
  overlay.addEventListener('click', closePanel);
  panel.querySelector('.oqv-close').addEventListener('click', closePanel);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && isOpen) closePanel();
  });

  document.body.addEventListener('click', e => {
    const t = e.target.closest('.oqv-trigger-btn');
    if (t) { e.preventDefault(); e.stopPropagation(); openQuickView(t.dataset.handle); }
  });

  document.getElementById('oqv-atc-btn').addEventListener('click', () => {
    if (selectedVariantId) addToCart(selectedVariantId);
  });

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    injectTriggerButtons();
    new MutationObserver(injectTriggerButtons)
      .observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();